<!-- Profit Rank -->
<template>
  <div class="pr-list-page">
    <div class="pr-list-main-section">
      <div class="pr-list-header">
        <button
          v-if="isSaveButtonVisible"
          class="prList-button"
          @click="saveGridData(annualTop40GridApi, '1')"
        >
          저장
        </button>
        <button
          v-if="isSaveButtonVisible"
          class="prList-button"
          @click="copyAnnualTop40Data"
        >
          복사
        </button>
        {{ currentYear }}년 선임금 사업순수익 40위
        <span class="unit">(단위: 만원)</span>
      </div>

      <ag-grid-vue
        class="ag-pr-balham annual-grid"
        :style="{ width: '100%', height: gridHeight + 'rem' }"
        :rowData="annualTop40Data"
        :columnDefs="annualTop40Defs"
        :theme="theme"
        :gridOptions="annualTop40GridOptions"
        :rowHeight="rowHeight"
        @grid-ready="onAnnualTop40GridReady"
      />
    </div>
    <div class="pr-list-middle-table">
      <div class="pr-list-header">
        <button
          v-if="isSaveButtonVisible"
          class="prList-button"
          @click="saveGridData(monthlyTop40GridApi, '2')"
        >
          저장
        </button>
        <button
          v-if="isSaveButtonVisible"
          class="prList-button"
          @click="copyMonthlyTop40Data"
        >
          복사
        </button>
        {{ previousMonth }}월 사업순수익 40위
        <span class="unit">(단위: 만원)</span>
      </div>
      <ag-grid-vue
        class="ag-pr-balham monthly-grid"
        :style="{ width: '100%', height: gridHeight + 'rem' }"
        :rowData="monthlyTop40Data"
        :columnDefs="monthlyTop40Defs"
        :theme="theme"
        :gridOptions="monthlyTop40GridOptions"
        :rowHeight="rowHeight"
        @grid-ready="onMonthlyTop40GridReady"
      />
    </div>
    <div class="pr-list-main-section">
      <div class="pr-list-header">
        <button
          v-if="isSaveButtonVisible"
          class="prList-button"
          @click="saveGridData(branchTop3GridApi, '3')"
        >
          저장
        </button>
        <button
          v-if="isSaveButtonVisible"
          class="prList-button"
          @click="copyBranchTop3Data"
        >
          복사
        </button>
        본부별 순수익 선임금 TOP 4 <span class="unit">(단위: 만원)</span>
      </div>
      <ag-grid-vue
        class="ag-pr-balham branch-grid"
        :style="{ width: '100%', height: gridHeight + 'rem' }"
        :rowData="branchTop3Data"
        :columnDefs="branchTop3Defs"
        :theme="theme"
        :gridOptions="branchTop3GridOptions"
        :rowHeight="rowHeight"
        @grid-ready="onBranchTop3GridReady"
      />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";

export default {
  name: "PrListPage",
  components: { AgGridVue },
  data() {
    const now = new Date();
    now.setMonth(now.getMonth() - 1);
    const previousMonth = (now.getMonth() + 1).toString().padStart(2, "0");

    return {
      userInfo: null, // 로그인한 사용자 정보

      currentYear: new Date().getFullYear(),

      previousMonth,

      rowHeight: window.innerWidth > 1024 ? 19 : 16, // 행 높이

      gridHeight: window.innerWidth > 1024 ? 50 : 42.5, // 그리드2 높이

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        headerHeight: 35,
        rowHeight: 16,
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      gridApi: null,
      columnApi: null,

      annualTop40GridApi: null,
      annualTop40ColumnApi: null,
      annualTop40Data: [],
      annualTop40Defs: [
        {
          headerName: "",
          field: "lROW",
          width: 15,
          flex: 0.3,
          resizable: false,
          cellStyle: { textAlign: "center", backgroundColor: "#d2ffe8" },
        },
        {
          headerName: "본부",
          field: "sBRANCH_NM",
          width: 30,
          flex: 0.5,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "점포명",
          field: "sSHOP_NM",
          width: 58,
          flex: 1.2,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "순수익\n선임금",
          field: "lAMT_N1",
          width: 40,
          flex: 0.7,
          cellStyle: this.getProfitCellStyle,
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString();
          },
        },
        {
          headerName: "가져간\n순이익",
          field: "lAMT_N2",
          width: 40,
          flex: 0.7,
          cellStyle: this.getProfitCellStyle,
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString();
          },
        },
        {
          headerName: "합계\n순수익",
          field: "lAMT_SUM",
          width: 40,
          flex: 0.7,
          cellStyle: this.getProfitCellStyle,
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString();
          },
        },
        {
          headerName: "사업주명",
          field: "sEMP_NM",
          width: 49,
          flex: 0.8,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "나이",
          field: "lAGE",
          width: 30,
          flex: 0.28,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "운영",
          field: "lCAREER",
          width: 30,
          flex: 0.37,
          cellStyle: this.getProfitCellStyle,
        },
      ],
      annualTop40GridOptions: {
        // ensureDomOrder: true,
        // enableCellTextSelection: true,
        // suppressMovableColumns: true,
        // suppressClipboardPaste: false,

        defaultColDef: {
          wrapHeaderText: true,
          // editable: true,
          resizable: true,
          sortable: true,
          comparator: (valueA, valueB) => {
            const isANumber = !isNaN(parseFloat(valueA)) && isFinite(valueA);
            const isBNumber = !isNaN(parseFloat(valueB)) && isFinite(valueB);

            if (isANumber && isBNumber) {
              return valueA - valueB;
            }
            if (!isANumber && !isBNumber) {
              return String(valueA).localeCompare(String(valueB));
            }
            return isANumber ? -1 : 1;
          },
          headerStyle: {
            backgroundColor: "#d2ffe8",
            color: "black",
            textAlign: "center",
            alignContent: "center",
          },
        },
        rowSelection: { mode: "singleRow", checkboxes: false },
        // rowSelection: "multiple",
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        domLayout: "autoHeight",
      },

      monthlyTop40GridApi: null,
      monthlyTop40ColumnApi: null,
      monthlyTop40Data: [],
      monthlyTop40Defs: [
        {
          headerName: "",
          field: "lROW",
          width: 15,
          flex: 0.3,
          cellStyle: { textAlign: "center", backgroundColor: "#ffffc0" },
        },
        {
          headerName: "본부",
          field: "sBRANCH_NM",
          width: 30,
          flex: 0.5,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "점포명",
          field: "sSHOP_NM",
          width: 55,
          flex: 1.1,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "순수익\n금액",
          field: "lAMT_N1",
          width: 40,
          flex: 0.7,
          cellStyle: this.getProfitCellStyle,
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString();
          },
        },
        {
          headerName: "사업주명",
          field: "sEMP_NM",
          width: 49,
          flex: 0.8,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "나이",
          field: "lAGE",
          width: 30,
          flex: 0.28,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "운영",
          field: "lCAREER",
          width: 30,
          flex: 0.35,
          cellStyle: this.getProfitCellStyle,
        },
      ],
      monthlyTop40GridOptions: {
        defaultColDef: {
          wrapHeaderText: true,
          resizable: true,
          sortable: true,
          comparator: (valueA, valueB) => {
            const isANumber = !isNaN(parseFloat(valueA)) && isFinite(valueA);
            const isBNumber = !isNaN(parseFloat(valueB)) && isFinite(valueB);

            if (isANumber && isBNumber) {
              return valueA - valueB;
            }
            if (!isANumber && !isBNumber) {
              return String(valueA).localeCompare(String(valueB));
            }
            return isANumber ? -1 : 1;
          },
          headerStyle: {
            backgroundColor: "#ffffc0",
            color: "black",
          },
        },
        rowSelection: { mode: "singleRow", checkboxes: false },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        domLayout: "autoHeight",
      },

      branchTop3GridApi: null,
      branchTop3ColumnApi: null,
      branchTop3Data: [],
      branchTop3Defs: [
        {
          headerName: "",
          field: "sBRANCH_CD",
          hide: true, // 숨김 컬럼
        },
        {
          headerName: "본부",
          field: "sBRANCH_NM",
          width: 30,
          flex: 0.5,
          cellStyle: this.getBranchTop3CellStyle,
          // spanRows: true,  //사용못함
          rowSpan: this.calculateRowSpan,
        },
        {
          headerName: "NO",
          field: "NO",
          width: 15,
          flex: 0.3,
          cellStyle: this.getBranchTop3CellStyle,
        },
        {
          headerName: "점포명",
          field: "sSHOP_NM",
          width: 60,
          flex: 1.2,
          cellStyle: this.getBranchTop3CellStyle,
        },
        {
          headerName: "순수익\n선임금",
          field: "lAMT_N1",
          width: 40,
          flex: 0.7,
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString();
          },
          cellStyle: this.getBranchTop3CellStyle,
        },
        {
          headerName: "가져간\n순이익",
          field: "lAMT_N2",
          width: 40,
          flex: 0.7,
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString();
          },
          cellStyle: this.getBranchTop3CellStyle,
        },
        {
          headerName: "합계\n순수익",
          field: "lAMT_SUM",
          width: 40,
          flex: 0.7,
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString();
          },
          cellStyle: this.getBranchTop3CellStyle,
        },
        {
          headerName: "사업주명",
          field: "sEMP_NM",
          width: 49,
          flex: 0.8,
          cellStyle: this.getBranchTop3CellStyle,
        },
        {
          headerName: "나이",
          field: "lAGE",
          width: 30,
          flex: 0.28,
          cellStyle: this.getBranchTop3CellStyle,
        },
        {
          headerName: "운영",
          field: "lCAREER",
          width: 30,
          flex: 0.37,
          cellStyle: this.getBranchTop3CellStyle,
        },
      ],
      branchTop3GridOptions: {
        enableCellSpan: true,
        defaultColDef: {
          wrapHeaderText: true,
          resizable: true,
          sortable: true,
          comparator: (valueA, valueB) => {
            const isANumber = !isNaN(parseFloat(valueA)) && isFinite(valueA);
            const isBNumber = !isNaN(parseFloat(valueB)) && isFinite(valueB);

            if (isANumber && isBNumber) {
              return valueA - valueB;
            }
            if (!isANumber && !isBNumber) {
              return String(valueA).localeCompare(String(valueB));
            }
            return isANumber ? -1 : 1;
          },
          headerStyle: {
            backgroundColor: "#c2fffe",
            color: "black",
          },
        },
        rowSelection: { mode: "singleRow", checkboxes: false },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        // domLayout: "autoHeight",
        suppressRowTransform: true, // 행 병합 시 필수 (렌더링 최적화 및 오류 방지)
      },

      branchColors: {
        "01": "#ffe3c6",
        "02": "#84ff84",
        "03": "#bcddfe",
        "04": "#ffffc6",
        "05": "#ffc3c6",
        "06": "#e7cffe",
        "07": "#ffff00",
        "08": "#c6ffc6",
        "09": "#ffe6ff",
        "10": "#ceffff",
        "11": "#b7ff7f",
      },
    };
  },

  created() {
    Promise.all([
      this.loadAnnualTop40(),
      this.loadMonthlyTop40(),
      this.loadBranchTop3(),
    ]);
  },

  mounted() {
    // localStorage에서 사용자 정보 불러오기
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }

    window.addEventListener("resize", this.handleResize);

    document.addEventListener("paste", this.handlePaste);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("paste", this.handlePaste);
  },

  computed: {
    isSaveButtonVisible() {
      // '관리자'가 아닐 경우에만 저장 버튼을 표시합니다.
      return (
        this.userInfo &&
        ["관리자", "한병재", "장영환", "김완수", "이도건"].includes(
          this.userInfo.EMP_NM
        )
      );
    },
  },

  methods: {
    async loadAnnualTop40() {
      // API 호출
      // const res = await axios.get("/api/prListPage/annualTop40");
      const res = await axios.get("/api/prListPage/", {
        params: {
          index: 1,
        },
      });
      this.annualTop40Data = res.data;
      // 샘플 데이터
    },
    async loadMonthlyTop40() {
      // API 호출
      const res = await axios.get("/api/prListPage/", {
        params: {
          index: 2,
        },
      });
      this.monthlyTop40Data = res.data;
    },
    async loadBranchTop3() {
      // API 호출
      const res = await axios.get("/api/prListPage/", {
        params: {
          index: 3,
        },
      });
      this.branchTop3Data = res.data;
    },
    getBranchTop3CellStyle(params) {
      // const year = params.data?.years;
      const branchCd = params.data?.sBRANCH_CD;
      const value = params.value;
      const columnId = params.column.colId;

      const style = {};

      style.textAlign = "center"; // 본부명과 연도 셀은 가운데 정렬
      style.alignContent = "center";
      // const field = params.colDef.field;
      if (branchCd && this.branchColors[branchCd]) {
        if (
          params.data?.NO == 1 ||
          columnId == "NO" ||
          columnId == "sSHOP_NM"
        ) {
          style.background = this.branchColors[branchCd];
        }
      }

      if (isNaN(value) || params.colDef.field == "NO") {
        style.textAlign = "center";
      } else {
        style.textAlign = "right";
      }

      if (columnId == "lAMT_SUM") {
        style.color = "#d33";
      }

      return style;
    },

    getProfitCellStyle(params) {
      const columnId = params.column.colId;
      const value = params.value;
      const headerName = params.colDef.headerName;
      const style = {};

      if ([5, 10, 15, 20, 25, 30, 35, 40].includes(params.node.rowIndex + 1)) {
        const colors = [
          "#ffe3c6",
          "#84ff84",
          "#bcddfe",
          "#ffffc6",
          "#ffc3c6",
          "#e7cffe",
          "#ffff00",
          "#c6ffc6",
        ];
        style.background = colors[Math.floor(params.node.rowIndex / 5)];
      }

      if (isNaN(value)) {
        style.textAlign = "center";
      } else {
        style.textAlign = "right";
      }

      if (
        (columnId == "lAMT_SUM" && headerName == "합계\n순수익") ||
        (columnId == "lAMT_N1" && headerName == "순수익\n금액")
      ) {
        style.color = "#d33";
      }

      return style; // 기본 스타일
    },

    handleResize() {
      const isWide = window.innerWidth > 1024;
      const newRowHeight = isWide ? 19 : 16;
      const newGridHeight = isWide ? 50 : 42.5;
      if (this.rowHeight !== newRowHeight) {
        this.rowHeight = newRowHeight;
        if (this.gridApi) this.gridApi.resetRowHeights();
      }
      if (this.gridHeight !== newGridHeight) {
        this.gridHeight = newGridHeight;
      }
    },

    onAnnualTop40GridReady(params) {
      this.annualTop40GridApi = params.api;
      this.annualTop40ColumnApi = params.columnApi;
    },

    onMonthlyTop40GridReady(params) {
      this.monthlyTop40GridApi = params.api;
      this.monthlyTop40ColumnApi = params.columnApi;
    },
    onBranchTop3GridReady(params) {
      this.branchTop3GridApi = params.api;
      this.branchTop3ColumnApi = params.columnApi;
    },
    copyAnnualTop40Data() {
      this.copyData(this.annualTop40GridApi);
    },
    copyMonthlyTop40Data() {
      this.copyData(this.monthlyTop40GridApi);
    },
    copyBranchTop3Data() {
      this.copyData(this.branchTop3GridApi);
    },
    copyData(gridApi) {
      const csvData = gridApi.getDataAsCsv({
        // 헤더 가공: \n 제거
        processHeaderCallback: (params) => {
          const def = params.column.getColDef();
          const header = def.headerName ?? def.field ?? "";
          return String(header).replace(/\r?\n/g, " "); // 줄바꿈 → 공백
        },
        // 셀 값 가공(필요하면): 셀 안의 줄바꿈도 제거
        processCellCallback: (params) => {
          const v = params.value;
          if (v == null) return "";
          return String(v).replace(/\r?\n/g, " ");
        },
        // 엑셀 친화 옵션
        columnSeparator: "\t", // 탭 구분 → 엑셀에 바로 셀 분리
        suppressQuotes: true, // 큰따옴표 억제(헤더에 따옴표 생기는 문제 방지)
      });

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(csvData)
          .then(() => alert("복사되었습니다."))
          .catch((err) => console.error("Clipboard copy failed: ", err));
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = csvData;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("복사되었습니다.");
      }
    },

    handlePaste(event) {
      // 현재 포커스된 Element가 ag-grid 내부인지 확인
      const focusedElement = document.activeElement;
      const annualGrid = document.querySelector(".annual-grid");
      const monthlyGrid = document.querySelector(".monthly-grid");
      const branchGrid = document.querySelector(".branch-grid");

      let targetDefs;
      let targetApi;

      // 포커스된 그리드 확인
      if (annualGrid?.contains(focusedElement)) {
        targetDefs = this.annualTop40Defs;
        targetApi = this.annualTop40GridApi;
      } else if (monthlyGrid?.contains(focusedElement)) {
        targetDefs = this.monthlyTop40Defs;
        targetApi = this.monthlyTop40GridApi;
      } else if (branchGrid?.contains(focusedElement)) {
        targetDefs = this.branchTop3Defs;
        targetApi = this.branchTop3GridApi;
      } else {
        return; // 그리드 외부면 리턴
      }

      // 클립보드 데이터 가져오기
      const clipboardData = event.clipboardData.getData("text");
      const rows = clipboardData.split(/\r\n|\n|\r/);

      // 현재 선택된 셀의 위치 가져오기
      const focusedCell = targetApi.getFocusedCell();
      if (!focusedCell) return;

      const startRow = focusedCell.rowIndex;
      const startCol = targetDefs.findIndex(
        (col) => col.field === focusedCell.column.colId
      );

      // 데이터 붙여넣기
      rows.forEach((row, rowIndex) => {
        const cells = row.split("\t");
        cells.forEach((cell, colIndex) => {
          const rowNode = targetApi.getDisplayedRowAtIndex(startRow + rowIndex);
          if (!rowNode) return;

          const colId = targetDefs[startCol + colIndex]?.field;
          if (!colId) return;

          if (colId === "lAGE" || colId === "lCAREER") {
            const numValue = parseInt(cell.trim(), 10);
            if (!isNaN(numValue)) {
              rowNode.setDataValue(colId, numValue);
            }
          } else {
            rowNode.setDataValue(colId, cell.trim());
          }
        });
      });

      event.preventDefault(); // 브라우저 기본 붙여넣기 동작막기
    },

    //   saveGridData(gridApi, type) {
    //   const rowData = gridApi.getDataAsCsv();
    //   const rows = rowData.split('\n');
    //   const data = [];
    //   for (let i = 1; i < rows.length; i++) {
    //     const row = rows[i].split(',');
    //     const vShop_nm = row[1].trim();
    //     if (vShop_nm !== '') {
    //       const vBranch_nm = row[0];
    //       const vAMT_N1 = row[2];
    //       const vAMT_N2 = row[3];
    //       const vAMT_SUM = row[4];
    //       const vEMP_NM = row[5];
    //       const vAGE = row[6];
    //       const vCAREER = row[7];
    //       data.push({
    //         type,
    //         vBranch_nm,
    //         vShop_nm,
    //         vAMT_N1,
    //         vAMT_N2,
    //         vAMT_SUM,
    //         vEMP_NM,
    //         vAGE,
    //         vCAREER
    //       });
    //     }
    //   }
    //   console.log("data:"+JSON.stringify(data));
    //   console.log("userInfo:"+JSON.stringify(this.userInfo));
    //   // 데이터를 서버에 전송하여 저장합니다.
    //   // axios.post('/api/saveGridData', { data })
    //   //   .then(response => {
    //   //     console.log(response);
    //   //   })
    //   //   .catch(error => {
    //   //     console.error(error);
    //   //   });
    // },
    async saveGridData(gridApi, index) {
      if (!gridApi) {
        alert("그리드를 찾을 수 없습니다.");
        return;
      }

      const confirmed = window.confirm("저장하시겠습니까?");
      if (!confirmed) return;

      const rowData = [];
      gridApi.forEachNode((node) => {
        // 점포명이 있는 유효한 데이터만 추출합니다.
        if (node.data && node.data.sSHOP_NM) {
          rowData.push(node.data);
        }
      });

      if (rowData.length === 0) {
        alert("저장할 데이터가 없습니다.");
        return;
      }

      const payload = {
        index: index,
        gridData: rowData,
        // 저장하는 사용자의 정보를 함께 보냅니다. (백엔드 API 명세에 맞게 수정)
        savedBy: this.userInfo ? this.userInfo.EMP_NM : "Unknown",
      };

      try {
        // 실제 사용하는 API 엔드포인트로 교체해야 합니다.
        await axios.post("/api/prListPage/savePrList", payload);
        alert("성공적으로 저장되었습니다.");
      } catch (error) {
        console.error("Failed to save grid data:", error);
        alert("데이터 저장 중 오류가 발생했습니다.");
      }
    },

    calculateRowSpan(params) {
      if (!params.data || !params.data.sBRANCH_NM) return 1;
      const sBRANCH_NM = params.data.sBRANCH_NM;
      const rowIndex = params.node.rowIndex;

      // 이전 행과 값이 같으면 1 반환 (병합된 셀의 일부로 처리됨)
      if (rowIndex > 0) {
        const prevNode = params.api.getDisplayedRowAtIndex(rowIndex - 1);
        if (prevNode && prevNode.data && prevNode.data.sBRANCH_NM === sBRANCH_NM) {
          return 1;
        }
      }

      // 이후 행들과 값이 같은지 확인하여 병합할 행 수 계산
      let count = 1;
      let nextIndex = rowIndex + 1;
      let nextNode = params.api.getDisplayedRowAtIndex(nextIndex);

     while (nextNode && nextNode.data && nextNode.data.sBRANCH_NM === sBRANCH_NM) {
      count++;
      nextIndex++;
      nextNode = params.api.getDisplayedRowAtIndex(nextIndex);
      }
      return count;

    },
  },
};
</script>

<style scoped>
.pr-list-page {
  display: flex;
  flex-direction: row;
  gap: 5px;
  padding-left: 5px;
  padding-right: 5px;
}
.pr-list-main-section {
  flex: 1.3;
  width: 30%;
}
.pr-list-middle-table {
  flex: 1;
  width: 30%;
}

.pr-list-header {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: right;
  font-size: 1rem;
  font-weight: bold;
}
.unit {
  font-size: 0.7rem;
  color: #0000ff;
}

.prList-button {
  padding: 0px;
  font-size: 0.6rem;
  margin-left: 2px;
  display: block;
  float: left; /* 왼쪽 정렬 */
}

:deep(.ag-pr-balham) {
  /* font-size: 0.95rem; */
  --ag-cell-horizontal-padding: 2px; /* 셀 내부 좌우 패딩 */
  --ag-cell-vertical-padding: 1px; /* 셀 내부 상하 패딩 */
}

:deep(.ag-pr-balham .ag-header-cell-comp-wrapper) {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* grid 헤더 텍스트 정렬 */
:deep(.ag-pr-balham .ag-header-cell-label) {
  justify-content: center !important;
  white-space: pre-line;
  align-items: center !important;
  font-weight: normal;
  font-size: 0.75rem;
}

:deep(.ag-pr-balham .ag-cell) {
  font-size: 0.75rem;
  text-align: right;
  /* padding-right: 3px; */
}

/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  :deep(.ag-pr-balham .ag-cell) {
    font-size: 0.85rem;
  }
  :deep(.ag-pr-balham .ag-header-cell-text) {
    font-size: 0.85rem;
  }
  .pr-list-header {
    font-size: 1.1rem;
  }
  .prList-button {
    font-size: 0.7rem;
  }
}
</style>
